module.exports = __webpack_public_path__ + "static/img/adver_m.bf88676.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/System/adver_m.png
// module id = rSVW
// module chunks = 4